<script setup lang="ts">
import { useStudentStore } from '@/stores/student'

const studentStore = useStudentStore()
</script>

<template>
  <VCard class="dashboard-card dashboard-card--small dashboard-card--notifications h-100 d-flex flex-column pa-0">
    <VCardText class="d-flex flex-column justify-space-between pa-2">
      <div class="d-flex align-center py-2">
        <div class="pl-2 pr-4 position-relative">
          <VIcon icon="mdi-bell-outline" size="2.3rem" class="dashboard-card--notifications__icon" />
          <VBadge
            v-if="studentStore.has_unread_notifications"
            color="error"
            :content="studentStore.unread_notification_count"
            class="dashboard-card--notifications__badge position-absolute"
            inline
          />
        </div>
        <p class="font-weight-medium text-branding-grey">
          <span v-if="studentStore.has_unread_notifications">{{ $t('pages.dashboard.notifications.has_notifications', { notificationNb: studentStore.unread_notification_count }) }}</span>
          <span v-else>{{ $t('pages.dashboard.notifications.no_notifications') }}</span>
        </p>
      </div>
      <VBtn variant="tonal" rounded="xl" to="notifications" class="dashboard-card--notifications__view-btn w-100">
        {{ $t('pages.dashboard.notifications.view_btn') }}
      </VBtn>
    </VCardText>
  </VCard>
</template>
